import React from 'react'
import { motion, MotionConfig } from 'motion/react'
import { Tag } from '../../constants/tags'
import CloseButton from '../CloseButton'
import TagFilterButton, { TagFilterButtonName } from './TagFilterButton'
import { closeButtonVariants, overlayVariants } from './filterAnimation'

// from left to right, so the buttons pop in sweeping across the screen
const filterButtons: { name: TagFilterButtonName; tag: Tag }[] = [
  { name: 'floral', tag: Tag.FLORAL },
  { name: 'human', tag: Tag.HUMAN },
  { name: 'geometric', tag: Tag.GEOMETRIC },
  { name: 'bird', tag: Tag.BIRD },
  { name: 'animal', tag: Tag.ANIMAL },
  { name: 'religious', tag: Tag.RELIGIOUS },
  { name: 'text', tag: Tag.TEXT },
  { name: 'pattern', tag: Tag.PATTERN },
  { name: 'crest', tag: Tag.CREST },
  { name: 'shape', tag: Tag.SHAPE },
]

// Rendered inside AnimatePresence, so it stays until the overlay has faded out
const TagFilterOverlay = (props: { onSelect: (tag: Tag) => void; onClose: () => void }) => {
  const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const el = e.target as HTMLElement
    if (el.classList.contains('outside')) {
      props.onClose()
    }
  }

  return (
    <MotionConfig reducedMotion="user">
      <motion.div
        className="outside absolute top-0 flex h-full w-screen items-center before:pointer-events-none before:fixed before:bottom-0 before:left-0 before:right-0 before:top-0 before:z-0 before:h-screen before:w-screen before:bg-[rgba(0,0,0,0.8)] before:content-['']"
        variants={overlayVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={handleOutsideClick}
      >
        <div className="fixed top-1/2">
          {filterButtons.map(button => (
            <TagFilterButton
              key={button.name}
              name={button.name}
              tag={button.tag}
              onSelect={props.onSelect}
            />
          ))}
        </div>
      </motion.div>
      <CloseButton
        // the css transition would trail behind every frame of the animation
        className="[transition:none]"
        variants={closeButtonVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={props.onClose}
      />
    </MotionConfig>
  )
}

export default TagFilterOverlay
